export const formErrors = ($r, $formGroups) => {
    const $generalError = $r.find('.govuk-error-summary');

    return {
        setError: (key, error) => {
            $formGroups[key].addClass('govuk-form-group--error');
            const $errorMessage = $formGroups[key].find('.govuk-error-message');
            $errorMessage.removeClass('invisible');
            $errorMessage.find('.error-message-content').get(0).innerText = error;
        },
        clearError: (key) => {
            $formGroups[key].removeClass('govuk-form-group--error');
            const $errorMessage = $formGroups[key].find('.govuk-error-message');
            $errorMessage.addClass('invisible');
        },
        setGeneralError: (error) => {
            $generalError.removeClass('invisible');
            $generalError.find('.general-error-message-content').get(0).innerText = error;
        },
        clearGeneralError: () => {
            $generalError.addClass('invisible');
        },
    };
};